import { ModalContext } from 'App';
import PinInput from 'modules/common/components/PinInput';
import React, { useContext, useEffect, useState } from 'react';
import APP_VERSION from 'version';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import PropTypes from 'prop-types';
import _, { isEmpty } from 'lodash';
import CmsContext from 'CmsContext';
import { get, getJson, removeItem, set } from 'session';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from 'modules/auth/actions';
import * as c from 'modules/auth/constants';
import Modal from 'modules/common/components/Modal';
import Countdown from 'react-countdown';
import styles from './LogInModal.module.css';
/* eslint-disable import/no-cycle */
import SignUpModalNew from './SignUpModalNew';
import LoginContainerModal from './LoginContainerModal';

const renderer = ({ minutes, seconds, completed }) => {
  if (completed) {
    return (
      <span>
        Your OTP is <b>EXPIRED</b>
      </span>
    );
  }
  return (
    <span>
      The OTP will expire in{' '}
      <span className='font-weight-bold'>
        ({minutes}:{`0${seconds}`.slice(-2)})
      </span>
    </span>
  );
};

const secretMobileNumber = (mobile_number) => {
  return [...mobile_number].map((item, i) => (i > 1 && i < 9 ? '*' : item));
};

const INIT_STATE = {
  mobile_number: '',
  pin: '',
  password: '',
  first_name: '',
  last_name: '',
};

const SignUpPinModal = ({ resendOTP, resending, isLoading, login, history, remainingTime }) => {
  const cmsContext = useContext(CmsContext);
  const LOGOS = cmsContext.findByType('LOGOS');
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(INIT_STATE);
  const [date, setDate] = useState(() => {
    if (remainingTime) return Date.now() + remainingTime * 1000;
    const storageCD = get('cd');
    if (storageCD === null) return Date.now() + 300 * 1000;
    return Date.now() + parseInt(storageCD, 10) * 1000;
  });

  useEffect(() => {
    const signupFormData = getJson('signupFormData');
    if (!isEmpty(signupFormData)) {
      setFormData((prev) => ({
        ...prev,
        mobile_number: signupFormData?.mobile_number || signupFormData?.email,
        password: signupFormData.password,
        first_name: signupFormData.first_name,
        last_name: signupFormData.last_name,
      }));
    }
  }, []);

  const resetCD = () => {
    setDate(Date.now() + 300 * 1000);
  };

  const handleOnchange = (pin) => {
    setFormData((prev) => ({
      ...prev,
      pin,
    }));
  };

  const handleBack = () => {
    setModal({
      isOpen: true,
      content: <SignUpModalNew />,
      title: null,
      modalSize: 'modal-login',
      hideHeader: true,
      isCentered: true,
    });
  };

  const handleResendOtp = () => {
    const args = { mobile_number: formData?.mobile_number };
    resendOTP(args, () => {
      resetCD();
    });
  };

  const handleOpenAuthModal = () => {
    setModal({
      isOpen: true,
      content: <LoginContainerModal />,
      title: null,
      modalSize: 'modal-login',
      hideHeader: true,
      isCentered: true,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    login(formData, () => {
      history.push('/');
      setModal({ isOpen: false });
      removeItem('signupFormData');
      removeItem('cd');
    });
  };

  const handleTick = ({ minutes, seconds }) => {
    set('cd', minutes * 60 + seconds);
  };

  return (
    <Modal.Body>
      <div className='d-flex flex-column w-full p-3'>
        <img
          className='relative'
          src={
            _.get(LOGOS, 'MAIN_LOGO.cdnUrl', '') || _.get(LOGOS, 'MAIN_LOGO', '') || defaultPhoto
          }
          alt=''
          width={120}
          height={35}
        />

        <div className={`${styles['login-welcome']} my-1`}>Welcome!</div>
        <div className={styles['login-description']}>One Time Password (OTP)</div>

        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <div className='form-wrapper mt-3' style={{ padding: '0px' }}>
            <div className='alert alert-primary text-center' role='alert'>
              We sent your One Time Password (OTP) to{' '}
              <i className='text-success font-weight-bold'>
                {secretMobileNumber(formData.mobile_number)}
              </i>
            </div>
            <PinInput onChange={handleOnchange} />
          </div>
          <div className='row justify-content-center mt-3'>
            <Countdown
              onTick={handleTick}
              date={date}
              // onComplete={handleCountdownComplete}
              renderer={renderer}
            />
          </div>
          <div className={styles['login-action-container']} style={{ paddingTop: '15px' }}>
            <button
              type='submit'
              disabled={isLoading}
              className='w-full inline-block text-center rounded-md bg-slate-800 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600 border border-slate-900'
            >
              {isLoading && <i className='fa fa-spin fa-spinner' />} Submit
            </button>
            <button
              type='button'
              onClick={handleResendOtp}
              disabled={isLoading}
              className='w-full inline-block text-center rounded-md bg-white px-5 py-2.5 text-sm font-semibold text-slate-800 shadow-sm hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600 border border-slate-900'
            >
              {resending && <i className='fa fa-spin fa-spinner' />} Resend OTP
            </button>
            <button
              type='button'
              onClick={handleBack}
              className='w-full inline-block text-center rounded-md bg-white px-5 py-2.5 text-sm font-semibold text-slate-800 shadow-sm hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600 border border-slate-900'
            >
              Back
            </button>

            <p className='text-xs text-center w-full mt-3'>{APP_VERSION}</p>

            <div
              className={styles['login-signup-here']}
              role='button'
              tabIndex='0'
              onClick={handleOpenAuthModal}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleOpenAuthModal();
                }
              }}
            >
              Already have an account? <b>Log in here.</b>
            </div>
          </div>
        </form>
      </div>
    </Modal.Body>
  );
};

SignUpPinModal.defaultProps = {
  remainingTime: 0,
};

SignUpPinModal.propTypes = {
  resendOTP: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  login: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  remainingTime: PropTypes.number,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(c.REGISTER) > -1,
  resending: _.get(api, 'loading', []).indexOf(c.RESEND_OTP) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SignUpPinModal);
